import React from 'react'
import { formatCustomerPaymentCardType } from '@@partner:helpers/formatters/card_type'

import { Tag } from 'rsuite'

export interface CustomerCardTypeLabelProps {
  type: string
}

export default function CustomerCardTypeLabel ({
  type
}: CustomerCardTypeLabelProps) {
  const { label, color = null } = formatCustomerPaymentCardType(type)
  return (
    <Tag className="u-status-badge" color={color}>
      {label}
    </Tag>
  )
}
